import { render, staticRenderFns } from "./addMedicl.vue?vue&type=template&id=f9bcd666&"
import script from "./addMedicl.vue?vue&type=script&lang=js&"
export * from "./addMedicl.vue?vue&type=script&lang=js&"
import style0 from "./addMedicl.vue?vue&type=style&index=0&id=f9bcd666&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports